import React, { useEffect, useRef, useState } from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { InputText } from "primereact/inputtext";
import { useNavigate } from "react-router-dom";
import { Api } from "../../../services/api";
import { ConfirmDialog, } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Dropdown } from "primereact/dropdown";
import { Tag } from "primereact/tag";

const PM_DASHBOARD = () => {
    const toast = useRef(null);
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(true);
    const [activeIndex, setActiveIndex] = useState(0);
    const [projects, setProjects] = useState([]);
    const [searchprojects, setSearchprojectsProjects] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);


    /** //*search Filtter function Start */
    const [filters, setFilters] = useState(null);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };
    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            project_name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            first_name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            last_name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            ProjectType: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },



        });
        setGlobalFilterValue('');
    };
    /** //!search Filtter function End */

    const header = (
        <div className="flex flex-wrap align-items-center justify-content-between m-2">
            <div></div>
            <span className="flex-grow p-input-icon-left" style={{ order: 1 }}>
                <InputText
                    className="input-field"
                    type="search"
                    value={globalFilterValue}
                    onChange={onGlobalFilterChange}
                    placeholder="Search..."
                />
            </span>
        </div>
    );

    var ProjectStatusList = ['ACTIVE', 'WARRANTY', 'ARCHIVE', 'HOLD', 'CANCELLED', 'COMPLETED'];

    useEffect(() => {
        let playbookSelectedColumnField = localStorage.getItem('playbookSelectedColumnField')

        if (playbookSelectedColumnField) {

            if (playbookSelectedColumnField != null && playbookSelectedColumnField != 'null') {
                setSelectedColumnField(playbookSelectedColumnField)
                getProject(playbookSelectedColumnField);
            } else {
                getProject('ALL');
            }
        } else {
            getProject('ALL');
        }



        initFilters();
        return () => {
            // Cleanup tasks before the component is unmounted
        };
    }, [activeIndex]);


    const getProject = async (projectStatus) => {
        setIsLoading(true);
        const token = localStorage.getItem('authToken');
        const headers = {
            'Authorization': token ? `Bearer ${token}` : '',
            "Content-Type": "application/json",
        };



        var _body = {

            status: projectStatus,
        }
        fetch(Api.API_BASE_URL + 'pm-template/all-project-get-by-status', {
            method: "POST",
            headers: headers,
            body: JSON.stringify(_body),
        })
            .then((response) => response.json())
            .then((response) => {


                setProjects(response.result);
                setSearchprojectsProjects(response.result);
                setIsLoading(false);


                let playbookRedirect = localStorage.getItem('playbookRedirect');
                if (playbookRedirect) {
                    playbookRedirect = JSON.parse(playbookRedirect)
                    setFirst(playbookRedirect.first || 0)
                    setRows(playbookRedirect.rows || 12)
                    setSortField(playbookRedirect.sortField || 'project_name')
                    setSortOrder(playbookRedirect.sortOrder || -1)

                } let playbookSelectedProduct = localStorage.getItem('playbookSelectedProduct');
                if (playbookSelectedProduct) {
                    playbookSelectedProduct = JSON.parse(playbookSelectedProduct)
                    setSelectedProduct(playbookSelectedProduct)


                }

                localStorage.removeItem('playbookSelectedProduct')
                localStorage.removeItem('playbookRedirect');
                localStorage.removeItem('playbookSelectedColumnField');


            })
            .catch((error) => {
                setIsLoading(false);
                console.error("Error:", error);
            });
    };

    // ------------------------------------
    const edit = (id, projectId, value) => {
        localStorage.setItem('playbookRedirect', JSON.stringify({
            rows: rows,
            first: first,
            sortField: sortField,
            sortOrder: sortOrder,

        }))


        localStorage.setItem('playbookSelectedProduct', JSON.stringify(value))
        localStorage.setItem('playbookSelectedColumnField', selectedColumnField)


        navigate('/view-playbook/' + projectId)
    }



    // ------------------------------------

    //* -------------------------

    const [selectedColumnField, setSelectedColumnField] = useState(null);

    const statusItemTemplate = (option) => {

        // *--------- Suraj Added 09-12-2024 ------------------
        console.log('option', option);
        let x = option;
        if (option == 'Warranty') {
            x = 'Warranty Complete'
        }
        if (option == 'Complete') {
            x = 'Construction Complete'
        }
        if (option == 'FSA Active') {
            x = 'FSA Construction'
        }
        // !--------- Suraj Added 09-12-2024 ------------------

        const displayStatus = option === 'ARCHIVE' ? 'COMPLETE' : option;

        const color = getSeverity(displayStatus);
        // return <Tag value={displayStatus} className='p-2' style={{ backgroundColor: color, color: '#FFFFFF' }} />;
        return <Tag value={x} className='p-2' style={{ backgroundColor: color, color: '#FFFFFF' }} />;


    };

    const getSeverity = (status) => {

        switch (status) {

            case 'Opportunity':
                return '#FFC107';

            case 'Lead Closed':
                return '#003366';

            case 'Lead Lost':
                return '#A9A9A9';

            case 'Lead Hold':
                return '#FFA500';

            case 'Lead Turned Down':
                return '#4F4F4F';

            case 'FSA Development':
                return '#87CEEB';

            case 'FSA Construction':
                return '#228B22';
            case 'FSA Active':
                return '#228B22';

            case 'FSA Hold':
                return '#556B2F';

            case 'FSA Cancelled':
                return '#8B0000';

            case 'Contract Active':
                return '#2E8B57';

            case 'Contract Hold':
                return '#D4AF37';

            case 'Contract Cancelled':
                return '#DC143C';

            case 'Construction Start':
                return '#FFA500';

            case 'Construction Complete':
                return '#4682B4';

            case 'Warranty Complete':
                return '#708090';

            default:
                return '#00AC47';
        }
    };

    const projectStatusRowFilterTemplate = (options) => {
        return (
            <Dropdown value={selectedColumnField} options={options} onChange={(e) => {

                console.log(e.value)
                if (e.value == undefined) {
                    setSelectedColumnField(null)
                    getProject('ALL');
                } else {
                    setSelectedColumnField(e.value)
                    getProject(e.value);
                }
            }
            } itemTemplate={statusItemTemplate} placeholder="Select One" className="p-column-filter" showClear style={{ minWidth: '12rem' }} />
        );
    };

    //! -------------------------
    const onRowSelect = (e) => {
        const rowData = e.data;
        setSelectedProduct(e.data)
        edit(e.data.id, e.data.projectId, e.data);
    };

    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(12);
    const [sortField, setSortField] = useState('project_name');
    const [sortOrder, setSortOrder] = useState(-1);
    const fetchData = async (event) => {
        const { first, rows, sortField, sortOrder } = event;
        setFirst(first);
        setRows(rows);
        setSortField(sortField);
        setSortOrder(sortOrder);
    }
    const DataTableTabView = () => {
        return (
            <div className="m-0 pm-data-table-wrapper" style={{ width: "100%" }} >
                <DataTable
                    value={projects}
                    paginator


                    rows={rows}
                    first={first}
                    sortField={sortField}
                    sortOrder={sortOrder}
                    onPage={fetchData}
                    onSort={fetchData}
                    totalRecords={projects.length}


                    filterDisplay="row"
                    dataKey="id"

                    selectionMode="single"
                    selection={selectedProduct}
                    onRowSelect={onRowSelect}
                    onRowUnselect={onRowSelect}


                    header={header}
                    filters={filters}
                    globalFilterFields={['project_name', 'ProjectType', 'first_name', 'last_name']}
                    className="p-datatable-sm compact-datatable"
                    scrollable
                    scrollHeight="flex"

                >

                    <Column sortable field="new_status" header="Project Status" body={(e) => statusItemTemplate(e.new_status)} frozen style={{ minWidth: '8rem', position: 'sticky', textAlign: 'center' }} filter filterElement={() => projectStatusRowFilterTemplate(['FSA Development', 'FSA Construction', 'FSA Hold', 'FSA Cancelled', 'Contract Active', 'Contract Hold', 'Contract Cancelled', 'Construction Start', 'Construction Complete', 'Warranty Complete',])} showFilterMenu={false}></Column>

                    <Column sortable field="project_name" header="Project Name" style={{ minHeight: '20px', }}></Column>
                    <Column sortable field="ProjectType" header="Project Type" ></Column>
                    <Column sortable field="pM" header="Project Manager" body={(e) => <span>{e.first_name} {e.last_name}</span>}></Column>
                    <Column sortable field="development_manager" header="Development Manager" body={(e) => <span>{e.da_first_name} {e.da_last_name}</span>}></Column>
                    <Column sortable field="pre_con_manager" header="Pre con Manager" body={(e) => <span>{e.pcm_first_name} {e.pcm_last_name}</span>}></Column>
                    <Column sortable field="interior_design" header="Interior Designer Manager" body={(e) => <span>{e.ind_first_name} {e.ind_last_name}</span>}></Column>
                    <Column sortable field="job_autospy" header="JOB AUTOPSY" body={(e) => <span>{e.Ja_first_name} {e.Ja_last_name}</span>}></Column>
                    <Column sortable field="warranty" header="Warranty" body={(e) => <span>{e.Wa_first_name} {e.Wa_last_name}</span>}></Column>
                </DataTable>
            </div>
        )
    }


    return (
        <><Toast ref={toast} />
            <ConfirmDialog />
            <div className="pagination-datable-height pm-dashboard-height">

                {isLoading ? (
                    <div className="loading-spinner">
                        Loading...
                        <div className="spinner"></div>
                    </div>
                ) : (

                    <div className="pagee-container">

                        {DataTableTabView()}
                    </div>
                )}
            </div>
        </>
    )
}

export default PM_DASHBOARD;